import { useSelector } from 'react-redux';
import AppState from '../../actions/app';

const usePrintableStates = () => {
  const states = useSelector(AppState.selectors.printableStates());
  return states;
};

export default usePrintableStates;
